
export function newsletterForm() {
  $(".newsletter-form").submit(function(e) {
    e.preventDefault()
    const $form = $(this)
    const $resultElement = $form.find(".result")
    const name = $form.find("input[type='text']").val()
    const email = $form.find("input[type='email']").val()
    const privacy = $form.find('input[type=checkbox]').prop('checked')
    const list = window.latino.mccallback
    let error = $form.find("input[name='error']").val()
    if (!email || !email.length || (email.indexOf("@") == -1)) {
      $resultElement.text($form.find("input[name='error_email']").val())
    } else if (!privacy) {
      $resultElement.text($form.find("input[name='error_privacy']").val());
    } else {
      if(!$form.hasClass("disabled")) {
        $form.addClass("loading");
        $resultElement.html("");
        const formData = new FormData()
        formData.append('mauticform[formId]', 1)
        formData.append('mauticform[messenger]', 1)
        formData.append('mauticform[name]', name)
        formData.append('mauticform[email]', email)
        fetch(list, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
        .then(response => response.text())
        .then(result => {
          $form.removeClass("loading");
          var message = result.includes('results') ? 'Thank you for a message' : error;
          $resultElement.text(message);
        })
        .catch(() => {
          $form.removeClass("loading");
          $resultElement.html(error);
        });
      }
    }
  })
}
